import React from "react";
import Proptypes from "prop-types";
import { Grid } from "@gcs/design-system/react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import AlertContent, {
  AlertGrid,
  AlertGridIconConteiner,
  AlertaIcon,
} from "./Alert.Style";

const Alert = (props) => {
  const { children, icon: Icon } = props;

  return (
    <AlertContent {...props} spaceSlim>
      <AlertGrid as={Grid}>
        <AlertGridIconConteiner
          as={Grid.Item}
          xs={1 / 5}
          sm={1 / 5}
          md={1 / 12}
        >
          <AlertaIcon as={Icon} />
        </AlertGridIconConteiner>
        <Grid.Item
          xs={4 / 5}
          sm={4 / 5}
          md={11 / 12}
          className="Alert__Content"
        >
          {children}
        </Grid.Item>
      </AlertGrid>
    </AlertContent>
  );
};

Alert.defaultProps = {
  icon: AiOutlineInfoCircle,
};

Alert.propTypes = {
  icon: Proptypes.elementType,
};

export default Alert;
